var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import format from 'string-format';
import { useTranslation } from 'react-i18next';
import { useInfiniteQuery } from '@tanstack/react-query';
import { NODES_PATH } from '../nodes';
import { decodeReadPortLogsResponse } from '../../../types/lighthouse/decoders/nodes/node-id/port-logs';
import { useLighthouseFetch } from '@/hooks/use-lighthouse-fetch';
var PORT_LOGS_PATH = 'port_logs';
export function formatPortLogsPath(nodeId) {
    if (nodeId === void 0) { nodeId = ':nodeId'; }
    return "".concat(NODES_PATH, "/").concat(nodeId, "/").concat(PORT_LOGS_PATH);
}
export function usePortLogs(nodeId, queryParams, _a) {
    var _this = this;
    var getNextPageParam = _a.getNextPageParam;
    var _b = useLighthouseFetch(), executeFetch = _b.executeFetch, decodeResponse = _b.decodeResponse, handleCommonStatusCodes = _b.handleCommonStatusCodes;
    var t = useTranslation().t;
    var fetchPortLogs = useCallback(function (_a) {
        var pageParam = _a.pageParam, signal = _a.signal;
        return __awaiter(_this, void 0, void 0, function () {
            var response, _b, data, status, translations;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, executeFetch(formatPortLogsPath(nodeId), { queryParams: __assign(__assign({}, queryParams), { page: pageParam }), signal: signal })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, decodeResponse(decodeReadPortLogsResponse, response)];
                    case 2:
                        _b = _c.sent(), data = _b.data, status = _b.status;
                        translations = __assign(__assign({}, t('api.port_logs.get')), { not_found: { message: format(t('api.port_logs.get.not_found.message'), nodeId) } });
                        handleCommonStatusCodes(data, status, translations);
                        return [2 /*return*/, status === 200 ? data : null];
                }
            });
        });
    }, [decodeResponse, executeFetch, handleCommonStatusCodes, nodeId, queryParams, t]);
    return useInfiniteQuery({
        queryKey: [PORT_LOGS_PATH, nodeId, queryParams],
        queryFn: fetchPortLogs,
        getNextPageParam: getNextPageParam,
        initialPageParam: 1,
    });
}
